<template>
  <Popover class="relative flex">
    <PopoverButton
      class="inline-flex items-center text-sm font-light text-gray-500 rounded-md sm:text-base group hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 dark:hover:text-gray-400"
    >
      <span>Skip</span>
    </PopoverButton>

    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel class="absolute z-10 w-screen max-w-sm px-4 pb-10 mt-10 transform -translate-y-full -left-5 sm:left-1/2 sm:-translate-x-1/2 sm:px-0 lg:max-w-sm">
        <div class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
          <div class="relative grid gap-8 bg-white p-7 dark:bg-gray-700 lg:grid-cols-1">
            <button
              v-for="item in skipOptions"
              :key="item.name"
              :href="item.href"
              type="button"
              @click="$emit('skip', item.action)"
              class="flex items-center p-2 -m-3 text-left transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50 dark:hover:bg-gray-500"
            >
              <div class="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded bg-slate-50 stroke-slate-300 dark:bg-slate-200 dark:stroke-slate-600 sm:h-12 sm:w-12">
                <div v-html="item.icon"></div>
              </div>
              <div class="ml-4">
                <p class="text-sm font-medium text-gray-900 dark:text-white">
                  {{ item.name }}
                </p>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                  {{ item.description }}
                </p>
              </div>
            </button>
          </div>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
export default {
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
  },
  setup() {
    const skipOptions = [
      {
        name: "Tomorrow",
        description: "Skip this for now. Review it again tomorrow.",
        action: "defer",
        icon: `
          <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-8 h-8"
          fill="none"
          viewBox="0 0 24 24"
          
          stroke-width="2">

            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>`,
      },
      {
        name: "Permanently",
        description: "Remove this task permanently.",
        action: "delete",
        icon: `
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            class="w-8 h-8"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              stroke-width="2"
            />
          </svg>`,
      },
    ];

    return {
      skipOptions,
    };
  },
};
</script>
